import request from '../../utils/request';

export async function getDelegationCollectionRuleRequest(params) {
  return request({
    url: 'delegationCollectionRule/getDictData',
    method: 'get',
    headers: 'json',
    params,
  });
}

export async function updateDelegationCollectionRuleRequest(params) {
  return request({
    url: 'delegationCollectionRule/updateDictData',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function getDelegationCollectionRuleCalculateResultRequest(params) {
  return request({
    url: 'delegationCollectionRule/calculateResult',
    method: 'get',
    headers: 'json',
    params,
  });
}

export async function calculateDelegationCollectionRuleRequest(params) {
  return request({
    url: 'delegationCollectionRule/calculate',
    method: 'post',
    headers: 'json',
    params,
  });
}
